import React from 'react';
import { AimieRobotAvatarIcon, UserAvatarIcon } from '../chat/ChatAvatarIcons';

const LOADING_MS = 1400;
const RESPONSE_DELAY_MS = 1400;
const LOOP_PAUSE_MS = 2500;

const EXERCISE_TURNS = [
  {
    speaker: 'client',
    text: 'I keep saying I want to cut back, but stress hits and I light up before I even think about it.',
  },
  {
    speaker: 'counsellor',
    text: 'Smoking feels automatic when the stress starts building.',
  },
  {
    speaker: 'client',
    text: 'Exactly. Part of me is tired of that, but part of me still depends on it.',
  },
];

const USER_RESPONSE = 'You are caught between wanting more control and relying on smoking to get through the moment.';

function DemoMessage({ speaker, text }) {
  const isClient = speaker === 'client';

  return (
    <div className={`anonymous-landing__skill-demo-message anonymous-landing__skill-demo-message--${speaker}`}>
      {isClient && (
        <span className="anonymous-landing__skill-demo-avatar" aria-hidden="true">
          <AimieRobotAvatarIcon />
        </span>
      )}
      <div className="anonymous-landing__skill-demo-bubble-shell">
        <div className={`anonymous-landing__skill-demo-bubble anonymous-landing__skill-demo-bubble--${speaker}`}>
          {text}
        </div>
      </div>
      {!isClient && (
        <span className="anonymous-landing__skill-demo-avatar" aria-hidden="true">
          <UserAvatarIcon avatarId="human-curly" avatarBackground="155" />
        </span>
      )}
    </div>
  );
}

function LoadingGhost() {
  return (
    <div className="anonymous-landing__skill-demo-loading-body" aria-hidden="true">
      <div className="anonymous-landing__skill-demo-loading-row anonymous-landing__skill-demo-loading-row--left">
        <div className="anonymous-landing__skill-demo-loading-bubble anonymous-landing__skill-demo-loading-bubble--wide">
          <span className="anonymous-landing__skill-demo-loading-line anonymous-landing__skill-demo-loading-line--long" />
          <span className="anonymous-landing__skill-demo-loading-line anonymous-landing__skill-demo-loading-line--mid" />
        </div>
      </div>
      <div className="anonymous-landing__skill-demo-loading-row anonymous-landing__skill-demo-loading-row--right">
        <div className="anonymous-landing__skill-demo-loading-bubble anonymous-landing__skill-demo-loading-bubble--reply">
          <span className="anonymous-landing__skill-demo-loading-line anonymous-landing__skill-demo-loading-line--mid" />
          <span className="anonymous-landing__skill-demo-loading-line anonymous-landing__skill-demo-loading-line--short" />
        </div>
      </div>
      <div className="anonymous-landing__skill-demo-loading-row anonymous-landing__skill-demo-loading-row--left">
        <div className="anonymous-landing__skill-demo-loading-bubble anonymous-landing__skill-demo-loading-bubble--wide">
          <span className="anonymous-landing__skill-demo-loading-line anonymous-landing__skill-demo-loading-line--long" />
          <span className="anonymous-landing__skill-demo-loading-line anonymous-landing__skill-demo-loading-line--short" />
        </div>
      </div>
    </div>
  );
}

export default function SpecificSkillModalDemo() {
  const [phase, setPhase] = React.useState('loading');
  const [cycle, setCycle] = React.useState(0);

  React.useEffect(() => {
    let cancelled = false;
    const timeoutIds = [];

    const registerTimeout = (callback, ms) => {
      const id = window.setTimeout(() => {
        if (!cancelled) {
          callback();
        }
      }, ms);
      timeoutIds.push(id);
    };

    const runLoop = () => {
      setPhase('loading');
      setCycle((current) => current + 1);

      registerTimeout(() => {
        setPhase('exercise');
      }, LOADING_MS);

      registerTimeout(() => {
        setPhase('response');
      }, LOADING_MS + RESPONSE_DELAY_MS);

      registerTimeout(runLoop, LOADING_MS + RESPONSE_DELAY_MS + LOOP_PAUSE_MS);
    };

    runLoop();

    return () => {
      cancelled = true;
      timeoutIds.forEach((id) => window.clearTimeout(id));
    };
  }, []);

  return (
    <div className="anonymous-landing__skill-demo" aria-hidden="true">
      <div className="anonymous-landing__skill-demo-top">
        {phase === 'loading' ? (
          <LoadingGhost />
        ) : (
          <div key={`skill-demo-${cycle}`} className="anonymous-landing__skill-demo-exercise anonymous-landing__demo-panel-content--animated">
            {EXERCISE_TURNS.map((turn, index) => (
              <DemoMessage
                key={`${turn.speaker}-${index}`}
                speaker={turn.speaker}
                text={turn.text}
              />
            ))}
          </div>
        )}
      </div>
      <div className="anonymous-landing__skill-demo-cut">
        <span className="anonymous-landing__skill-demo-cut-line" />
        <span className="anonymous-landing__skill-demo-cut-label">Your turn: what would you say next?</span>
        <span className="anonymous-landing__skill-demo-cut-line" />
      </div>
      <div className="anonymous-landing__skill-demo-response-slot">
        {phase === 'response' ? (
          <div className="anonymous-landing__skill-demo-response anonymous-landing__demo-panel-content--animated">
            <DemoMessage speaker="counsellor" text={USER_RESPONSE} />
          </div>
        ) : (
          <div className="anonymous-landing__skill-demo-response anonymous-landing__skill-demo-response--placeholder" />
        )}
      </div>
    </div>
  );
}
